import APIService from '@/services/api.service';
import UserService from '@/services/user.service';
import { Store } from '@/store.js';
import Q from 'q';

class DocumentSetsService {

    constructor() {}

    getOwned() {
        var service = this;
        return UserService.get()
            .then(getSetsFor)
            .then(transform);

        function getSetsFor(user) {
            var settings = APIService.defaultSettingsPlus({
                'url': APIService.baseURL + '/api/v1/users/' + user.id + '/owneddocumentsets'
            });
            return APIService.waitFor( Q($.ajax(settings)) );
        }

        function transform(response) {
            var sets = response.entities;
            for (var i in sets) {
                var set = sets[i];
                set.setType = 'owneddocumentsets';
                service.sortUserLinks(set);
            }
            return sets;
        }
    }

    getShared() {
        var service = this;
        return UserService.get()
            .then(getSetsFor)
            .then(transform);

        function getSetsFor(user) {
            var settings = APIService.defaultSettingsPlus({
                'url': APIService.baseURL + '/api/v1/users/' + user.id + '/shareddocumentsets'
            });
            return APIService.waitFor( Q($.ajax(settings)) );
        }

        function transform(response) {
            var sets = response.entities;
            for (var i in sets) {
                var set = sets[i];
                set.setType = 'shareddocumentsets';
                service.sortUserLinks(set);
            }
            return sets;
        }
    }

    getAll() {
        var service = this;
        return UserService.get()
            .then(getSetsFor)
            .spread(combine);

        function getSetsFor(user) {
            var settings = APIService.defaultSettingsPlus({});
            return Q.all( [ service.getOwned(), service.getShared() ] );
        }
        function combine(ownedSets, sharedSets) {
            return { ownedSets:ownedSets, sharedSets:sharedSets };
        }
    }

    getSet(setId, setType) {
        var service = this;
        return UserService.get()
            .then(getSetFor)
            .then(transform);

        function getSetFor(user) {
            var settings = APIService.defaultSettingsPlus({
                'url': APIService.baseURL + '/api/v1/users/' + user.id + '/' + setType + '/' + setId
            });
            return APIService.waitFor( Q($.ajax(settings)) );
        }

        function transform(response) {
            var set = response.entity;
            set.setType = setType;
            service.sortUserLinks(set);
            for (var i in set.documents) {
                set.documents[i].selected = false;
            }
            return set;
        }
    }

    categorizeSet(set) {
        var service = this;
        return categorize(set);

        function categorize(set) {
            var sortedDocuments = {};
            var categories = set.documents
                .map( a => a.documentCategory )
                .sort( (a,b) => a.rank - b.rank )
                .filter( (val, i, self) => self.indexOf(val) === i );
            for (var key in categories) {
                var category = categories[key];
                sortedDocuments[category.name] = set.documents
                    .filter( (val, i, self) => val.documentCategory.id === category.id )
                    .sort( (a,b) => a.rank - b.rank );
            }
            return sortedDocuments;
        }
    }

    sortUserLinks(set) {
        var service = this;
        set.owners = set.userLinks.filter( (userLink, i, self) => userLink.relationType == 'primary' );
        if (set.setType == 'owneddocumentsets') {
            set.attorneys = set.userLinks.filter( (userLink, i, self) => userLink.relationType == 'primary_attorney' );
            set.sharedUsers = set.userLinks.filter( (userLink, i, self) => userLink.relationType == 'shared' );
            set.staff = set.userLinks.filter( (userLink, i, self) => userLink.relationType == 'support_staff');
        }
        return set;
    }

}

export default new DocumentSetsService();


// WEBPACK FOOTER //
// ./src/services/document-sets.service.js